import { render, staticRenderFns } from "./PageColumnWithLiveList.vue?vue&type=template&id=343f3d1a&lang=pug&"
import script from "./PageColumnWithLiveList.vue?vue&type=script&lang=ts&"
export * from "./PageColumnWithLiveList.vue?vue&type=script&lang=ts&"
import style0 from "./PageColumnWithLiveList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports